<template>
  <main-content-layout
    :title="$gettext('OWNERSHIP_CHANGE_STEPPER_FILES')"
    :buttonTitle="$gettext('ADD_FILE')"
    :actionButton="openModal"
    buttonIconName="list"
  >
    <div class="tw-p-5">
      <jt-data-table
        id="jt-composition"
        :api-mode="false"
        :data="registros"
        :fields="columns"
        :is-paginated="false"
        :buttons="buttons"
        :title="titleTeble"
        row-buttons
        noneselect
        @action-button="actionButton"
      />
    </div>
    <service-request-attachment-modal
      ref="attachmentModal"
      :title="$gettext('OWNERSHIP_CHANGE_STEPPER_FILES')"
    />
    <modal
      ref="includModal"
      :show="flModal"
      :forms="forms"
      :label="this.$gettext('CONSUMER_UNIT_TYPE_QUANTITY')"
      @action-button="actionButtonModal"
    />
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestAttachmentController from './ServiceRequestAttachmentUnitController'
import { JtCrud } from 'jtech-webcomps'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
import ServiceRequestAttachmentModal from './ServiceRequestAttachmentModal.vue'
import { downloadFile } from './ServiceRequestAttachmentDownload'

const { modal } = JtCrud

@Component({
  name: 'ServiceRequest.registration-information.attachment',
  components: { modal, MainContentLayout, ServiceRequestAttachmentModal },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestAttachment extends Vue {
  controller = ServiceRequestAttachmentController.getInstance()
  datatable = null
  data = []
  composition = []
  flModal = false
  forms = null

  get columns () {
    return this.datatable?.columns
  }

  get buttons () {
    return this.datatable?.buttons
  }

  get registros () {
    return this.data?.registros
  }

  actionButton (button, params) {
    if (button.name == 'icDetalharArquivo' || button.name == 'icDownload') {
      if (params.available) {
        const nmIdentificacaoParserFile = 'CONSUMER_UNIT_FILE'
        if (button.name == 'icDetalharArquivo') {
          this.$refs.attachmentModal.show(params, (fileName) =>
            this.controller.downloadFile(fileName, 'CONSUMER_UNIT_FILE')
          )
        }
        if (button.name == 'icDownload') {
          this.handleDownload(params)
        }
      } else {
        this.$messageBox.warn(this.$gettext('INACTIVE_ATTACHMENT'))
      }
    }
  }

  async handleDownload (params) {
    try {
      const fileBlob = await this.controller.downloadFile(params.name, 'CONSUMER_UNIT_FILE')
      downloadFile(fileBlob, params.name)
    } catch (error) {
      this.$messageBox.error(error.message || 'An unexpected error occurred during download.')
    }
  }

  async mounted () {
    this.datatable = await this.controller.loadDatatable()
    await this.loadFiles()
  }

  async loadFiles () {
    const registros = await this.controller.loadDatatableModel({
      consumerUnit: parseInt(this.consumerUnit, 10)
    })
    this.data = registros
  }

  async openModal () {
    this.forms = await this.controller.loadForm()
    this.flModal = true
  }

  async actionButtonModal (params) {
    if (params.name == 'btGravar') {
      await this.controller.createUnitAttachment({
        consumerUnit: this.consumerUnit,
        ...this.forms[0].dadosForm
      })
      this.loadFiles()
      this.flModal = false
    }
  }
}
export default ServiceRequestAttachment
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

h6 {
  font-size: 20px;
  margin: 3px 20px;
  color: $light-d;
}

.layout {
  height: 700px;
  background-color: $off-white;
}

.q-btn {
  float: right;
}
</style>
